import { Routes } from '@angular/router';
import { RouteParams, RouteConstants, RouteSegments } from './constants/routeConstants';
import { UnsavedChangesGuard } from './guards/unsaved-changes.guard';

export const routes: Routes = [
  {
    path: RouteConstants.BASE,
    pathMatch: 'full',
    redirectTo: RouteConstants.TEST_ANALYSIS
  },
  {
    path: RouteConstants.SPECIFICATION_COVERAGE,
    loadComponent: () => import('./pages/test-items-list-old/test-items-list-old.component').then(m => m.TestItemListOldComponent),
    pathMatch: 'full',
  },
  {
    path: `${RouteSegments.SPECIFICATION_COVERAGE}/${RouteSegments.ADD}`,
    loadComponent: () => import('./pages/specification-coverage/specification-coverage.component').then(m => m.SpecificationCoverageComponent),
    pathMatch: 'full',
    canDeactivate: [UnsavedChangesGuard],
  },
  {
    path: `${RouteSegments.SPECIFICATION_COVERAGE}/:${RouteParams.TestItemUid}`,
    loadComponent: () => import('./pages/specification-coverage/specification-coverage.component').then(m => m.SpecificationCoverageComponent),
    pathMatch: 'full',
    canDeactivate: [UnsavedChangesGuard],
  },
  {
    path: RouteConstants.EESE_COVERAGE,
    loadComponent: () => import('./pages/test-items-list-old/test-items-list-old.component').then(m => m.TestItemListOldComponent),
    pathMatch: 'full',
  },
  {
    path: `${RouteSegments.EESE_COVERAGE}/${RouteSegments.ADD}`,
    loadComponent: () => import('./pages/eese-coverage/eese-coverage.component').then(m => m.EeseCoverageComponent),
    pathMatch: 'full',
    canDeactivate: [UnsavedChangesGuard],
  },
  {
    path: `${RouteSegments.EESE_COVERAGE}/:${RouteParams.TestItemUid}`,
    loadComponent: () => import('./pages/eese-coverage/eese-coverage.component').then(m => m.EeseCoverageComponent),
    pathMatch: 'full',
    canDeactivate: [UnsavedChangesGuard],
  },
  {
    path: RouteConstants.SOFTWARE_VERSION_COVERAGE,
    loadComponent: () => import('./pages/test-items-list-old/test-items-list-old.component').then(m => m.TestItemListOldComponent),
    pathMatch: 'full',
  },
  {
    path: `${RouteSegments.SOFTWARE_VERSION_COVERAGE}/${RouteSegments.ADD}`,
    loadComponent: () => import('./pages/software-version-coverage/software-version-coverage.component').then(m => m.SoftwareVersionCoverageComponent),
    pathMatch: 'full',
    canDeactivate: [UnsavedChangesGuard],
  },
  {
    path: `${RouteSegments.SOFTWARE_VERSION_COVERAGE}/:${RouteParams.TestItemUid}`,
    loadComponent: () => import('./pages/software-version-coverage/software-version-coverage.component').then(m => m.SoftwareVersionCoverageComponent),
    pathMatch: 'full',
    canDeactivate: [UnsavedChangesGuard],
  },
  {
    path: RouteConstants.RMS_SPECIFICATIONS_COMPARISON,
    loadComponent: () => import('./pages/rms-comparison/rms-comparison.component').then(m => m.RmsComparisonComponent),
    pathMatch: 'full',
  },
  {
    path: RouteConstants.TEST_CASES,
    loadComponent: () => import('./pages/test-item-list/test-item-list.component').then(m => m.TestItemListComponent),
    pathMatch: 'full',
  },
  {
    path: `${RouteSegments.TEST_CASES}/${RouteSegments.ADD}`,
    loadComponent: () => import('./pages/test-case/test-case.component').then(m => m.TestCaseComponent),
    pathMatch: 'full',
    canDeactivate: [UnsavedChangesGuard],
  },
  {
    path: `${RouteSegments.TEST_CASES}/${RouteSegments.IMPORT}`,
    loadComponent: () => import('./pages/tc-import/tc-import.component').then(m => m.TcImportComponent),
    pathMatch: 'full',
  },
  {
    path: `${RouteSegments.TEST_CASES}/:${RouteParams.TestItemUid}`,
    loadComponent: () => import('./pages/test-case/test-case.component').then(m => m.TestCaseComponent),
    pathMatch: 'full',
    canDeactivate: [UnsavedChangesGuard],
  },
  {
    path: RouteConstants.TEST_SUITES,
    loadComponent: () => import('./pages/test-items-list-old/test-items-list-old.component').then(m => m.TestItemListOldComponent),
    pathMatch: 'full',
  },
  {
    path: `${RouteSegments.TEST_SUITES}/${RouteSegments.ADD}`,
    loadComponent: () => import('./pages/test-suite/test-suite.component').then(m => m.TestSuiteComponent),
    pathMatch: 'full',
    canDeactivate: [UnsavedChangesGuard],
  },
  {
    path: `${RouteSegments.TEST_SUITES}/:${RouteParams.TestItemUid}`,
    loadComponent: () => import('./pages/test-suite/test-suite.component').then(m => m.TestSuiteComponent),
    pathMatch: 'full',
    canDeactivate: [UnsavedChangesGuard],
  },
  {
    path: RouteConstants.TEST_ANALYSIS,
    loadComponent: () => import('./pages/test-items-list-old/test-items-list-old.component').then(m => m.TestItemListOldComponent),
    pathMatch: 'full',
  },
  {
    path: `${RouteSegments.TEST_ANALYSIS}/${RouteSegments.ADD}`,
    loadComponent: () => import('./pages/test-analysis/test-analysis.component').then(m => m.TestAnalysisComponent),
    pathMatch: 'full',
    canDeactivate: [UnsavedChangesGuard],
  },
  {
    path: `${RouteSegments.TEST_ANALYSIS}/:${RouteParams.TestItemUid}`,
    loadComponent: () => import('./pages/test-analysis/test-analysis.component').then(m => m.TestAnalysisComponent),
    pathMatch: 'full',
    canDeactivate: [UnsavedChangesGuard],
  },
  {
    path: RouteConstants.TEST_SPECIFICATIONS,
    loadComponent: () => import('./pages/test-items-list-old/test-items-list-old.component').then(m => m.TestItemListOldComponent),
    pathMatch: 'full',
  },
  {
    path: `${RouteSegments.TEST_SPECIFICATIONS}/${RouteSegments.ADD}`,
    loadComponent: () => import('./pages/test-specification/test-specification.component').then(m => m.TestSpecificationComponent),
    pathMatch: 'full',
    canDeactivate: [UnsavedChangesGuard],
  },
  {
    path: `${RouteSegments.TEST_SPECIFICATIONS}/:${RouteParams.TestItemUid}`,
    loadComponent: () => import('./pages/test-specification/test-specification.component').then(m => m.TestSpecificationComponent),
    pathMatch: 'full',
    canDeactivate: [UnsavedChangesGuard],
  },
  {
    path: `${RouteSegments.REVIEW}`,
    loadComponent: () => import('./pages/review/review.component').then(m => m.ReviewComponent),
    pathMatch: 'full',
  }
];
